"use client";

import { ShieldCheck, Trophy } from "lucide-react";
import { useId, useState } from "react";
import { Tab, TabList } from "@nitro/ui";
import styles from "./SimulatorHubTabPanel.module.css";

export function SimulatorHubTabPanel({ competitionsContent, rankingContent = null, rankingLabel = "Ranking" }) {
  const id = useId();
  const tabs = [
    { key: "competencias", label: "Competencias", icon: Trophy, content: competitionsContent },
    rankingContent ? { key: "ranking", label: rankingLabel, icon: ShieldCheck, content: rankingContent } : null,
  ].filter(Boolean);
  const [activeTab, setActiveTab] = useState(tabs[0]?.key || "competencias");
  const activeContent = tabs.find((tab) => tab.key === activeTab)?.content || tabs[0]?.content || null;

  return (
    <>
      <TabList className={styles.tabs} ariaLabel="Secciones del simulador" value={activeTab} onValueChange={setActiveTab}>
        {tabs.map(({ icon: Icon, key, label }) => (
          <Tab
            controls={`${id}-panel`}
            id={`${id}-${key}`}
            key={key}
            value={key}
            icon={<Icon size={17} />}
          >
            {label}
          </Tab>
        ))}
      </TabList>
      <div className={styles.panel} role="tabpanel" id={`${id}-panel`} aria-labelledby={`${id}-${activeTab}`} tabIndex={0}>{activeContent}</div>
    </>
  );
}
